<template>
	<div class="report-right panel">
		<div class="report-right-con">
			<div class="panel-title">
				Top10搜索词
			</div>
			<div class="search-word-item">
				<div class="search-title">
					<div class="th-key-word key-word">搜索词</div>
					<div class="th-key-type key-type">浏览量(PV)</div>
					<div class="th-key-per key-per">占比</div>
				</div>
				<div class="search-word-con">
					<div class="search-row" v-for="(item, index) in searchWordData" :key="item.id" v-show="index <= 9">
						<div class="td-key-word key-word" :title="item.name">{{item.name}}</div>
						<div class="td-key-type key-type">{{item.pv_count}}</div>
						<div class="td-key-per key-per">{{item.pv_ratio}}%</div>
					</div>
				</div>
			</div>
			<p v-show="searchWordData.length === 0" style="text-align: center; margin-top: 100px;">暂无数据...</p>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters } from 'vuex'
export default {
	name: '',
	data() {
		return {
			loading: true,
		}
	},
	computed: {
		...mapState('siteStas', ['searchWordData']),
	},
	methods: {},
}
</script>

<style lang="scss" scoped>
	.panel-title {
		padding-left:15px;
		color: #373D45;
		font-weight: bolder;
		line-height: 15px;
		border-left: 4px solid $colorA;
		margin-bottom: 40px;
	}
    .report-right {
        min-height: 415px;
        width: 50%;
		float: right;
        .search-word-item {
			border-radius:4px;
			background:rgba(231,234,248,1);
			.search-title, .search-row{
				display: flex;
				justify-content: space-between;
				text-align: center;
				&>div{
					height: 40px;
					line-height: 40px;
				}
            }
        }
	}
	.search-row{
		border-bottom: 1px dashed #EAEBF0;
		&:hover{
			background-color: #EAEEFA;
		}
		&:last-child{
			border-bottom: 0;
		}
	}
	.report-right-con{
		margin: 0 auto;
		width: 60.9%;
		min-width: 512px;
	}
	.search-word-con{
		background: #fff;
		border-radius:4px;
		border:1px solid rgba(198,205,230,1);
		border-top: 0;
	}
	.key-word{
		width: 50.4%;
		padding-left: 20px;
		text-align: left;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.key-type{
		width: 20.5%;
	}
	.key-per{
		float: right;
		width: 16%;
	}
</style>
